<ng-container *ngIf="operatorsData">
  <div class="TableTitle">
    <h2 class="Report">Report</h2>
    <h1>List of operators</h1>
  </div>
  
  <div class="MobileOperators" *ngIf="operatorsData.length > 0">
    <ng-container *ngFor="let country of operatorsData">
      <div class="CountryBlock">
        <h3 class="CountryTitle">{{ country.countryName }}</h3>
        <div class="OperatorCard" *ngFor="let operator of country.operators">
          <div class="CardRow">
            <span class="Label">Operator : </span>{{ operator.brandName }}
          </div>
          <div class="CardRow">
            <span class="Label">Type : </span><span>{{ getOperatorTypeLabel(operator.type) }}</span>
          </div>
          <div class="CardRow">
            <span class="Label">Legal Name : </span><span class="Value" *ngIf="operator.legalName; else noLegal">{{ operator.legalName }}</span><ng-template #noLegal>/</ng-template>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <table class="table ResponsiveTable ResponsiveTable--withBorder ResponsiveTable--withHeaderMobile" *ngIf="operatorsData.length > 0">
    <thead class="AnimatedThead">
      <tr>
        <th scope="col">Country</th>
        <th scope="col">Operator (brand)</th>
        <th scope="col">Legal name</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let country of operatorsData">
       <tr *ngFor="let operator of country.operators; let i = index" [class.NoBorder]="i > 0">
          <td data-th="Country" class="NoWrap" *ngIf="i === 0" [attr.rowspan]="country.operators.length">
            {{ country.countryName }}
          </td>
          <td data-th="Operator (brand)">
            {{ operator.brandName }}<br>
            <span>{{ getOperatorTypeLabel(operator.type) }}</span>
          </td>
          <td data-th="Legal Name" [class.EmptyCell]="!operator.legalName">
            {{ operator.legalName }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <div class="NoResult" *ngIf="operatorsData.length === 0">
    <p>No operators available.</p>
  </div>
</ng-container>